import mainnetAddresses from "./mainnetAddresses.json";
export default {
  addresses: mainnetAddresses,
  chainId: 56,
  rpcUrl: "https://bsc-dataseed.binance.org/",
};
